var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"672ba454082707255a69581c9ae035020c1ddd17"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["landing-v2@staderlabs"]={id:"672ba454082707255a69581c9ae035020c1ddd17"};
      